import { render, staticRenderFns } from "./UserBankInfo.vue?vue&type=template&id=65c64b8c&scoped=true&"
import script from "./UserBankInfo.vue?vue&type=script&lang=js&"
export * from "./UserBankInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserBankInfo.vue?vue&type=style&index=0&id=65c64b8c&lang=less&scoped=true&"
import style1 from "./UserBankInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c64b8c",
  null
  
)

export default component.exports